$(".mobileMenu").on("click", function(){
    $(".mainNav").slideToggle('fast');
});